const __WEBPACK_NAMESPACE_OBJECT__ = require("@chakra-ui/react");